export const checkTypeData = [
  {
    value: '0',
    label: '请选择分类'
  },
  {
    value: '1',
    label: '机构核对'
  },
  {
    value: '2',
    label: '预审批'
  },
  {
    value: '3',
    label: '教育局复审'
  }
]
export const statusData = [
  {
    value: '0',
    label: '全部'
  },
  {
    value: '1',
    label: '待审批'
  },
  {
    value: '2',
    label: '审批通过'
  },
  {
    value: '3',
    label: '审批驳回'
  }
]

export const orgStatusData = [
  {
    value: '0',
    label: '全部'
  },
  {
    value: '1',
    label: '待确认'
  },
  {
    value: '2',
    label: '已确认'
  }
]

export const rlStatusData = [
  {
    value: '-1',
    label: '全部对账状态'
  },

  {
    value: '0',
    label: '待教务确认'
  },
  {
    value: '1',
    label: '待运营确认'
  },
  {
    value: '2',
    label: '待提供方确认'
  },
  {
    value: '3',
    label: '待收款单位审批'
  },
  {
    value: '4',
    label: '待教育局初审'
  },
  {
    value: '5',
    label: '待教育局复审'
  },
  {
    value: '99',
    label: '已对账'
  }
]

// 结算状态
export const stStatusData = [
  {
    value: '-1',
    label: '全部状态'
  },
  {
    value: '1',
    label: '已结算'
  },
  {
    value: '2',
    label: '待结算'
  },
  {
    value: '3',
    label: '结算中'
  }
]
